import React, { useEffect, useState } from "react";
import intro from "../../../../assets/introPage.jpeg";
import Largeintro from "../../../../assets/flipbook/extraLarge/Main.jpeg";

import materialIntro from "../../../../assets/materialIntro.jpg";
import siteIntro from "../../../../assets/SFR.jpeg";

import {
  getBase64ImageFromUrl,
  getOptimizedAssets,
} from "../../../../utils/helpers";
import { isPdfFile } from "pdfjs-dist";
import ImgOptimized from "../../../../components/ImgOptimized";
const Page01 = React.forwardRef((props, ref, width) => {
  console.log({ width });
  return (
    <div
      style={{
        backgroundImage: `url(${materialIntro})`,
        // backgroundSize: "contain",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",

        backgroundPosition: "left ",
        width: "100%",
        height: "100%",
      }}
      ref={ref}
      className="h-full w-full  bg-gray-100 rounded-xl relative"
    >
      {/*  <ImgOptimized src={intro} alt="Intro" className="w-full h-full " /> */}
      <div className="absolute w-[12%] aspect-square top-0 right-0 flex items-center justify-center   ">
        <div className="text-lg sm:text-xl lg:text-xl xl:text-2xl  text-[#E8B995] font-semibold  text-center text-wrap break-normal">
          {props?.projectName?.replaceAll("_", "/ ")}
        </div>
      </div>
    </div>
  );
});

export const SitePage01 = React.forwardRef((props, ref) => {
  console.log({ props });
  return (
    <div
      style={{
        backgroundImage: `url(${getOptimizedAssets([
          siteIntro,
          siteIntro,
          siteIntro,
          siteIntro,
        ])})`,
        // backgroundSize: "contain",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",

        backgroundPosition: "left ",
        width: "100%",
        height: "100%",
      }}
      ref={ref}
      className="h-full w-full  bg-gray-100  relative"
    >
      {/*  <ImgOptimized src={intro} alt="Intro" className="w-full h-full " /> */}

      <LogoPlacement {...props} isSite={true} />
    </div>
  );
});

export const RenderPage01 = React.forwardRef((props, ref) => {
  return (
    <div
      style={{
        backgroundImage: `url(${getOptimizedAssets([
          intro,
          intro,
          intro,
          intro,
        ])})`,
        // backgroundSize: "contain",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",

        backgroundPosition: "left ",
        width: "100%",
        height: "100%",
      }}
      ref={ref}
      className="h-full w-full  bg-gray-100  relative"
    >
      {/*  <ImgOptimized src={intro} alt="Intro" className="w-full h-full " /> */}
      {/* <div className='absolute  w-[330px] h-[85px] bottom-[65px] left-1/2 -translate-x-1/2 flex items-center justify-center  '>
  <div className='text-[1.8vw] text-white font-semibold  text-center'>
    {props?.projectName}
  </div>
  </div> */}
      <LogoPlacement {...props} />
    </div>
  );
});

export const ConceptualPage01 = React.forwardRef((props, ref) => {
  return (
    <div
      style={{
        backgroundImage: `url(${getOptimizedAssets([
          intro,
          intro,
          intro,
          intro,
        ])})`,
        // backgroundSize: "contain",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",

        backgroundPosition: "left ",
        width: "100%",
        height: "100%",
      }}
      ref={ref}
      className="h-full w-full  bg-gray-100  relative"
    >
      {/*  <ImgOptimized src={intro} alt="Intro" className="w-full h-full " /> */}
      {/* <div className='absolute  w-[330px] h-[85px] bottom-[65px] left-1/2 -translate-x-1/2 flex items-center justify-center  '>
  <div className='text-[1.8vw] text-white font-semibold  text-center'>
    {props?.projectName}
  </div>
  </div> */}
      <LogoPlacement {...props} />
    </div>
  );
});

export const LogoPlacement = (props) => {
  const [baseimg, setBaseimg] = useState(props?.companyLogo || "");
  const getBaseImg = async () => {
    if (props?.companyLogo) {
      const logo = await getBase64ImageFromUrl(props?.companyLogo);
      setBaseimg(logo);
    }
  };
  useEffect(() => {
    getBaseImg();
  }, [props?.companyLogo]);
  // if (props?.isSite) {
  //   return (
  //     <div className="absolute  w-[200px] sm:w-[240px]  lg:w-[180px] xl:w-auto 2xl:w-auto overflow-hidden  bottom-[40px] sm:bottom-[40px] lg:bottom-[25px] xl:bottom-[40px] left-[10px] sm:left-[20px] lg:left-[10px]  xl:left-30 flex items-center justify-center">
  //       {/* <div className=" text-sm sm:text-[2vw] md:text-[2vw] lg:text-[1.8vw] xl:text-[1.6vw] playfair italic text-[#084B53] font-bold  text-center gap-4  flex items-center  "> */}
  //       <div className="flex items-center justify-center ">
  //         {!props?.isPdf ? (
  //            <ImgOptimized
  //             src={props?.companyLogo}
  //             alt="Company Logo"
  //             className=" h-8 sm:h-14 lg:h-10 xl:h-12 2xl:h-14 max-w-[200px] sm:max-w-[240px]  lg:max-w-[180px] xl:max-w-fit 2xl:max-w-fit"
  //           />
  //         ) : (
  //            <ImgOptimized
  //             src={baseimg}
  //             alt="Company Logo"
  //             className="max-w-fit w-full h-14  "
  //           />
  //         )}
  //       </div>
  //       {/* {props?.projectName}  */}
  //       {/* </div> */}
  //     </div>
  //   );
  // }
  return (
    <div className="absolute bg-white w-[25%] aspect-[2/1] overflow-hidden  bottom-0 rounded-t-full left-[4.5%] flex flex-col  items-center justify-center">
      <div className="w-full h-[28%] 2xl:h-[32%] flex items-center justify-center">
        {/* <div className="h-5 bg-blue-500 w-full max-w-[70%]" > */}
        {/* adsf */}
        {!props?.isSite && (
          <>
            {!props?.isPdf ? (
              <ImgOptimized
                src={props?.companyLogo}
                alt="Company Logo"
                className=" max-h-full max-w-[65%]  xl:max-w-[10vw]"
              />
            ) : (
              <ImgOptimized
                src={baseimg}
                alt="Company Logo"
                className="max-h-full max-w-[65%] xl:max-w-[10vw] "
              />
            )}
          </>
        )}
        {/* </div> */}
      </div>
      <div
        className={` text-base sm:text-lg md:text-xl 2xl:text-2xl font-semibold text-center montserrat text-[#E8B995] ${
          props?.isPdf ? "relative bottom-4" : ""
        }`}
      >
        {props?.projectName}
      </div>
    </div>
  );
};
export default Page01;
